module.exports = __webpack_public_path__ + "img/LTS_BDO.39fbc20a.gif";